/**
 * 从传入的 url 或者 location 中, 获取单个指定 key 的 查询结果;
 * 返回 '' 空字符或者对应的值.
 * @param key
 * @param url
 */
export function getURLQuery(key, url) {
  var _global$location;

  var m = null;
  var search = (url ? "?".concat(url.split('?')[1] || '') : (_global$location = global.location) === null || _global$location === void 0 ? void 0 : _global$location.search) || '';

  if (search) {
    m = search.match(new RegExp("(\\?|&)".concat(key, "=([^&]*)(&|$)")));
  }

  return !m ? '' : decodeURIComponent(m[2]);
}
//# sourceMappingURL=utils.js.map